export const de = {
    // German translations:
    required: '* Pflichtfeld',
    validation: {
        required: controlName => `${controlName} eingeben`,
        minmaxNotLessThen: (controlName, min) => `${controlName} kann nicht kleiner als ${min} sein`,
        minmaxNotGreaterThen: (controlName, max) => `${controlName} kann nicht größer als ${max} sein`,
    },
    switch: {
        yes: 'Ja',
        no: 'Nein',
    },
    dateRange: {
        arrival: 'Anreise',
        departure: 'Abreise',
    },
    travelData: {
        title: 'Urlaubsdaten angeben und personalisierte Angebote direkt von den Gastgebern per Mail erhalten!',
        range: 'An- & Abreisedatum',
        hasPets: 'Reise mit Tieren',
        petsMessage: 'Haustier-Beschreibung',
        petsMessagePlaceholder: "z.B. 1 großer Hund (ca. 10 kg), 2 Katzen…",
        boards: 'Verpflegung',
        rooms: {
            validation: {
                roomsMissing: 'Mind. 1 Zimmer eingeben',
                adultsMissing: 'Anzahl Erwachsene eingeben',
                roomsWithoutAdults: 'Bei jedem Zimmer mind. 1 Erwachsenen eingeben',
                childAgeMissing: 'Alter der Kinder eingeben',
            },
            adults: 'Erwachsene',
            children: 'Kinder',
            rooms: 'Zimmer',
            age: 'Alter',
            room: 'Zimmer/Apartment',
            roomInfo: 'Diese Angabe entspricht einem Zimmer, einer Ferienwohnung, einem Stellplatz, etc.',
            removeRoom: 'Zimmer/Apartment entfernen',
            addRoom: 'Zimmer/Apartment hinzufügen',
            childrenAges: 'Alter der Kinder',
            years: age => `${age} ${age == 1 ? 'Jahr' : 'Jahre'}`,
            done: 'Fertig',
        },
        submit: 'Weiter',
    },
    filter: {
        title: 'Den gewünschten Unterkunftstyp und Ihre Lieblingsregion auswählen und Unterkunfts-Vorschläge erhalten!',
        accotypesValidatorText: controlName => `${controlName} auswählen`,
        areaValidatorText: controlName => `${controlName} auswählen`,
        maxCountValidatorText: (controlName, max) => `Es dürfen maximal ${max} Unterkünfte ausgewählt werden.\nNutzen Sie weitere Filter.`,
        accotypesAndBoards: 'Unterkunftstyp & Verpflegung',
        boards: 'Verpflegung',
        accotypes: 'Unterkunftstyp',
        areas: 'Regionen & Orte',
        resorts: 'Orte',
        regions: 'Regionen',
        selectAllRegions: 'Alle Regionen Südtirols auswählen',
        searchAreas: 'Regionen & Orte suchen…',
        themesAmeneties: 'Ausstattung / Urlaubsart',
        ameneties: 'Ausstattung',
        themes: 'Urlaubsart',
        overlay: {
            accosText: count => `<b>${count}</b> ${count == 1 ? "Unterkunft" : "Unterkünfte"} gewählt`,
            done: 'Fertig',
        },
        back: 'Zurück',
        submitContinueWith: 'Weiter mit',
        submitAccosText: count => `${count} ${count == 1 ? "Unterkunft" : "Unterkünften"}`,
    },
    accos: {
        title: 'Übersicht der Unterkünfte',
        subtitle: (selected, count) => `${selected} ${selected == 1 ? "Unterkunft" : "Unterkünfte"} anfragen oder einzelne auswählen`,
        back: 'Zurück',
        submitContinueWith: 'Weiter mit',
        submitAccosText: count => `${count} ${count == 1 ? "Unterkunft" : "Unterkünften"}`,
    },
    personalData: {
        accosCount: count => `<b>${count}</b> ${count == 1 ? "Unterkunft" : "Unterkünfte"}`,
        adults: count => `<b>${count}</b> ${count == 1 ? 'Erwachsener' : 'Erwachsene'}`,
        children: count => `<b>${count}</b> ${count == 1 ? 'Kind' : 'Kinder'}`,
        rooms: count => `<b>${count}</b> ${count == 1 ? 'Zimmer' : 'Zimmer'}`,
        pets: 'Haustier/e',
        accotypes: count => `${count == 1 ? 'Unterkunftstyp:' : 'Unterkunftstypen:'}`,
        areas: count => `${count == 1 ? 'Region/Ort:' : 'Regionen/Orte:'}`,
        
        title: 'Kontaktdaten eingeben, um personalisierte Angebote direkt von den Gastgebern zu erhalten!',
        email: 'E-Mail',
        salutation: 'Anrede',
        salutationOptions: {
            herr: 'Herr',
            frau: 'Frau',
            familie: 'Familie',
            firma: 'Firma',
        },
        firstname: 'Vorname',
        lastname: 'Nachname',
        phone: 'Telefon',
        message: 'Bemerkungen & Fragen',
        privacy: privacyUrl => `Ja, ich stimme der <a href="${privacyUrl}" target="_blank">Verarbeitung meiner personenbezogenen Daten</a> zu.`,
        privacyRequired: 'Stimmen Sie der Datenverarbeitung zu',
        newsletter: 'Ja, ich möchte den Newsletter von suedtirol.com erhalten.',
        newsletterNote: 'Unser kostenloser Newsletter wird regelmäßig etwa einmal pro Monat versendet. Er enthält die besten Angebote für einen Urlaub in Südtirol sowie aktuelle Tipps aus der Redaktion. Eine Abmeldung ist jederzeit möglich.',
        generalError: 'Es ist ein Fehler aufgetreten. Versuchen Sie es später nochmal.',
        back: 'Zurück',
        submit: count => `Jetzt Anfrage senden`,
    },
    thankyou: {
        title: 'Anfrage erfolgreich',
        successText: 'Ihre Anfrage wurde erfolgreich versendet',
    },
};
//# sourceMappingURL=Enquiry.i18n.de.js.map